import gql from 'graphql-tag';
import FieldsTable from "graphql/fields/FieldsTable";

export default gql(`
	query tables {
		tables {
			${FieldsTable}
			
			room {
				guid
			}
		}
	}
`);

